module.exports = __webpack_public_path__ + "static/media/whoa.1f6cdb5c.png";